import { styled } from '@mui/material/styles';
import { Box, Tabs, Tab, TextField } from '@mui/material';

export const Container = styled(Box)(({ theme }) => ({
    display: 'flex',
    height: '80vh',
    backgroundColor: theme.palette.background.default,
    overflowY: 'visible', 
}));

export const SidebarContainer = styled(Box)(({ theme }) => ({
    width: '320px',
    backgroundColor: theme.palette.background.paper,
    borderRight: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    overflowY: 'visible',
    borderRadius: '5px'
}));

export const ContentContainer = styled(Box)(() => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'visible',
}));

export const SearchBar = styled(TextField)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    '& .MuiOutlinedInput-root': {
        borderRadius: theme.shape.borderRadius,
    },
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.divider}`,
    '& .MuiTabs-indicator': {
        backgroundColor: theme.palette.secondary.main,
    },
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
    textTransform: 'none',
    minWidth: 80,
    marginRight: theme.spacing(2),
    '&.Mui-selected': {
        color: theme.palette.secondary.main,
        fontWeight: 500,
    },
}));

export const FormItem = styled(Box)(({ theme, selected }) => ({
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1.5),
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: selected ? theme.palette.action.selected : 'transparent',
    border: `1px solid ${selected ? theme.palette.secondary.main : 'transparent'}`,
    '&:hover': {
        backgroundColor: selected ? theme.palette.action.selected : theme.palette.action.hover,
    },
}));